module.exports = __webpack_public_path__ + "img/BW.fd16e02a.svg";